import * as R from 'remeda';
import type { AuditLogSourceType } from '@rossum/api-client/auditLogs';
import type { FeatureIconProps } from '@rossum/ui';
import {
  IconLayoutGrid,
  IconMail,
  IconMathFunction,
  type TablerIcon,
} from '@rossum/ui/icons/tabler';
import type { ActivitySource } from '../model';
import { isManualSource } from './sourceAttribution';

const SOURCE_ICONS: Record<AuditLogSourceType, TablerIcon> = {
  user: IconLayoutGrid,
  hook: IconLayoutGrid,
  rules: IconLayoutGrid,
  system: IconLayoutGrid,
  email: IconMail,
  formula_fields: IconMathFunction,
};

export const getInitials = (name: string): string =>
  R.pipe(
    name.split(/[\s.@+_-]+/),
    R.filter(R.isTruthy),
    R.take(2),
    R.map(part => part.charAt(0).toUpperCase()),
    R.join('')
  );

export const toFeatureIcon = (
  source: ActivitySource,
  name: string
): Pick<FeatureIconProps, 'content'> => ({
  content: isManualSource(source)
    ? getInitials(name)
    : SOURCE_ICONS[source.sourceType ?? 'system'],
});
